import "./src/styles/global.css";
import React from "react"
import CookieConsent from "./src/components/CookieConsent"

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <CookieConsent />
  </>
)

export const onClientEntry = () => {
  if (window.gtag) {
    window.gtag("consent", "default", {
      analytics_storage: "denied",
    })
  }
}
